import { render, staticRenderFns } from "./supplierList.vue?vue&type=template&id=3901b8d9"
import script from "./supplierList.vue?vue&type=script&lang=js"
export * from "./supplierList.vue?vue&type=script&lang=js"
import style0 from "./supplierList.vue?vue&type=style&index=0&id=3901b8d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports